import React from 'react';
import LegalDocumentLayout from '../components/legal/LegalDocumentLayout';

const TermsPage = () => <LegalDocumentLayout variant="terms" />;

export default TermsPage;
